import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-reject-modal',
  templateUrl: './reject-modal.component.html',
  styleUrls: ['./reject-modal.component.css']
})
export class RejectModalComponent implements OnInit {
  modalRef!: BsModalRef;
  constructor(public bsModalRef: BsModalRef,
  ) { this.modalRef = bsModalRef!; }

  ngOnInit() {
  }

}
